<template>
    <li :class="!item.registroActivo ? 'registroInactivo' : ''">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <div v-if="hasChildren" :id="'popover-tx-' + item.idTratamientoNuevo" class="d-flex align-items-center recuadro" @click="toggleBranch(item)"
           :style="item.isOpen ? 'background: #CEEBF0;' : item.idTratamientoPadre !== null ? 'background: #FFDBC7;' : ''">
        <div class="d-flex align-items-center " style="width: 90%" >
          <b-icon style="margin-right: .3em; margin-left: 0.5em;" icon="chevron-down" :rotate=" item.isOpen ? 180 : 0"></b-icon>
          <p class="mt-3 text-left" style="font-size: 12px;"> {{item.sku}} {{ item.nombre }}  </p>
        </div>
        <div class="d-flex" style="width: 10%" v-b-tooltip.hover.v-light.topright title="Este tratamiento tiene 1 o más hijos no configurados">
          <em v-if="item.subTratamientos.filter(c => !c.completo).length > 0" class="engrane_naranja_svg sm"></em>
        </div>
      </div>
      <div v-else :id="'popover-tx-' + item.idTratamientoNuevo" class="d-flex align-items-center recuadro"
           @click="seleccionarTratamiento(item)"
           :style="item.isOpen ? 'background: #CEEBF0;' : !item.completo ? 'background: #FFDBC7;' : ''">
        <div class="d-flex" style="width: 90%">
          <em v-if="item.registroActivo" class="tratamiento_outline" style="width: 1.4em; margin-left: 0.5em;"></em>
          <em v-else class="tratamiento_outline_inactivo" style="width: 1.4em; margin-left: 0.5em;"></em>
          <p class="mt-3 text-left" style="font-size: 12px;">{{ item.sku}} {{ item.nombre }} </p>
        </div>
<!--        <div class="d-flex" style="width: 10%">
          <em v-if="!item.completo" class="engrane_naranja_svg sm"></em>
        </div>-->
      </div>

      <b-popover v-if="!item.registroActivo" :target="'popover-tx-' + item.idTratamientoNuevo" triggers="hover" placement="topright">
        Este tratamiento está desactivado
      </b-popover>

      <ul style="padding-left: 20px" v-if="hasChildren && item.isOpen" :class="{ 'nested': true, 'active': item.isOpen }">
        <TreeItem
            @estaAbiertoTratamiento="estaAbiertoTratamiento"
          :idSeleccionado="idSeleccionado"
          v-for="(child, index) in item.subTratamientos"
          :item="child"
          :key="index"
        />
      </ul>
    </li>
  </template>

  <script>
  export default {
    name: 'TreeItem',
    props: {
      item: Object,
      idSeleccionado: {
          type: Number,
          default: null
        },
    },
    data() {
      return {
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
        auxiliarSeleccionadoHijo: 0
      };
    },
    computed: {
      hasChildren() {
        return this.item.subTratamientos && this.item.subTratamientos.length > 0;
      },
    },
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    methods: {
        seleccionarTratamiento(item){
          if (!this.hasChildren) {
            this.$emit('estaAbiertoTratamiento', item)
            item.isOpen = !item.isOpen;
          }

            this.$root.$emit('enviarTratamiento', item, this.idSeleccionado);
        },

        toggleBranch(item) {
          this.$emit('estaAbiertoTratamiento', this.item)
            this.item.isOpen = !this.item.isOpen;
          this.seleccionarTratamiento(item);
        },
      estaAbiertoTratamiento(item) {
        if (this.auxiliarSeleccionadoHijo !== item.idTratamientoNuevo) {
          this.auxiliarSeleccionadoHijo = item.idTratamientoNuevo;
          let abierto = this.item.subTratamientos.find(ct => ct.isOpen === true);
          if (abierto) {
            abierto.isOpen = false

            if (abierto.subTratamientos != null && abierto.subTratamientos.length > 0) {
              let abiertoHijos = abierto.subTratamientos.find(ct => ct.isOpen === true);
              if (abiertoHijos) {
                abiertoHijos.isOpen = false
              }
            }
          }
        } else {
          let abierto = this.item.subTratamientos.find(ct => ct.isOpen === true);
          if (abierto) {
            if (abierto.subTratamientos != null && abierto.subTratamientos.length > 0) {
              let abiertoHijos = abierto.subTratamientos.find(ct => ct.isOpen === true);
              if (abiertoHijos) {
                abiertoHijos.isOpen = false
              }
            }
          }
        }
      }
    },
  };
  </script>
  
  <style scoped>
  ul, #myUL {
    list-style-type: none;
  }
  
  #myUL {
    margin: 0;
    padding: 0;
  }

  .nested {
    display: none;
  }
  
  .active {
    display: block;
  }

  .recuadro {
    height: 2em;
    cursor: pointer;
    margin-bottom: 2px;
    margin-top: 2px;
    border-radius: 30px;
  }

  .registroInactivo {
    color: #B5B5B5;
  }
  </style>
  